import { Container, Row, Col, Tab, Nav } from "react-bootstrap";
import { ProjectCard } from "./ProjectCard";
import projImg1 from "../assets/img/objects.png";
import projImg2 from "../assets/img/face-rec2.png";
import projImg3 from "../assets/img/195.png";
import projImg4 from "../assets/img/travel.png";
import projImg5 from "../assets/img/image5.png";
import projImg6 from "../assets/img/illustration-gynecology-consultation-concept.png";
import projImg7 from "../assets/img/rholex2.png";
import projImg8 from "../assets/img/hr.png";
import colorSharp2 from "../assets/img/color-sharp2.png";
import 'animate.css';
import TrackVisibility from 'react-on-screen';

export const Projects = () => {

  const websites = [
    {
      title: "Mwanga Talent Advisory",
      description: "View Site",
      imgUrl: projImg8,
      // infoDescription: "View more information",
      link: "https://mwangatalent.com/",
      // moreInfoLink: "/mwangatalent",
    },

    {
      title: "Smart HRMS & Payroll System",
      description: "View Site",
      imgUrl: projImg5,
      // infoDescription: "View more information",
      link: "https://rhopay.rhokit.com/",
      // moreInfoLink: "/payroll",
    },
    {
      title: "eWallet System",
      description: "View Site",
      imgUrl: projImg7,
      // infoDescription: "View more information",
      link: "https://rholex.rhokit.com/",
      // moreInfoLink: "/payroll",
    },
    {
      title: "Kenya Tourism Guide",
      description: "View Github Repo",
      imgUrl: projImg4,
      infoDescription: "View more information",
      link: "https://github.com/joeygitari/second-year-project1",
      moreInfoLink: "/tourism",
    },
    {
      title: "Predictive Reproductive Healthcare System",
      description: "View Site",
      imgUrl: projImg6,
      infoDescription: "View more information",
      link: "https://blossom-health-project.web.app/",
      moreInfoLink: "/blossom-health",
    },
  
  ];

  const aiprojects = [
    {
      title: "Object Detector",
      description: "View Github Repo",
      imgUrl: projImg1,
      infoDescription: "View more information",
      link:"https://github.com/joeygitari/Object_Detector-App",
      moreInfoLink: "/object-detector",
    },
    {
      title: "Face Recognition",
      description: "View Github Repo",
      imgUrl: projImg2,
      infoDescription: "View more information",
      link:"https://github.com/joeygitari/Face_Recognition-App",
      moreInfoLink: "/face-recognition",
    },
    {
      title: "Language Translator",
      description: "View Github Repo",
      imgUrl: projImg3,
      infoDescription: "View more information",
      link:"https://github.com/joeygitari/Google-Translator-App",
      moreInfoLink: "/language-translator",
    },
  ];

  // const mobprojects = [
  //   {
  //     title: "Business Startup",
  //     description: "Design & Development",
  //     imgUrl: projImg1,
  //     link:"",
  //   },
  //   {
  //     title: "Business Startup",
  //     description: "Design & Development",
  //     imgUrl: projImg2,
  //     link:"",
  //   },
  //   {
  //     title: "Business Startup",
  //     description: "Design & Development",
  //     imgUrl: projImg3,
  //     link:"",
  //   },
  // ];

  return (
    <section className="project" id="projects">
      <Container>
        <Row>
          <Col size={12}>
            <TrackVisibility>
              {({ isVisible }) =>
              <div className={isVisible ? "animate__animated animate__fadeIn": ""}>
                <h2>Projects</h2>
                <Tab.Container id="projects-tabs" defaultActiveKey="first">
                  <Nav variant="pills" className="nav-pills mb-5 justify-content-center align-items-center" id="pills-tab">
                    <Nav.Item>
                      <Nav.Link eventKey="first">Websites</Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link eventKey="second">AI Apps</Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link eventKey="third">Mobile Apps</Nav.Link>
                    </Nav.Item>
                  </Nav>
                  <Tab.Content id="slideInUp" className={isVisible ? "animate__animated animate__slideInUp" : ""}>
                    <Tab.Pane eventKey="first">
                      <Row>
                        {
                          websites.map((website, index) => {
                            return (
                              <ProjectCard
                                key={index}
                                {...website}
                                />
                            )
                          })
                        }
                      </Row>
                      {/* <p>Relax, Content is coming soon 😉</p> */}
                    </Tab.Pane>
                    <Tab.Pane eventKey="second">
                    <Row>
                        {
                          aiprojects.map((aiproject, index) => {
                            return (
                              <ProjectCard
                                key={index}
                                {...aiproject}
                                />
                            )
                          })
                        }
                      </Row>
                      {/* <p>Relax, Content is coming soon 😉</p> */}
                    </Tab.Pane>
                    <Tab.Pane eventKey="third">
                    {/* <Row>
                        {
                          mobprojects.map((mobproject, index) => {
                            return (
                              <ProjectCard
                                key={index}
                                {...mobproject}
                                />
                            )
                          })
                        }
                      </Row> */}
                      <p>Coming soon :)</p>
                    </Tab.Pane>
                  </Tab.Content>
                </Tab.Container>
              </div>}
            </TrackVisibility>
          </Col>
        </Row>
      </Container>
      <img className="background-image-right" src={colorSharp2} alt=''></img>
    </section>
  )
}